module.exports = __webpack_public_path__ + "img/LocalConvenienceStoreOutlined.047fac55.svg";